
export class LuigisBoxProvider {

    static _getLbItem(product) {
        return {
            item_id: product.code ?? product.id,
            item_name: product.name,
            price: product.priceTable?.totalPriceExclVat ?? product.price
        };
    }

    // view_item — product detail page
    static sendProductDetail(product) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'view_item',
            ecommerce: {
                items: [LuigisBoxProvider._getLbItem(product)]
            }
        });
    }

    // view_item_list — search results
    static sendSearch(term, products, filters) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_name: 'Search Results',
                search_term: term,
                ...(filters && Object.keys(filters).length ? { filters } : {}),
                items: (products ?? []).map((p, i) => ({
                    ...LuigisBoxProvider._getLbItem(p),
                    index: i + 1,
                    type: 'item'
                }))
            }
        });
    }

    // view_item_list — autocomplete results
    static sendAutocomplete(term, categories, products) {
        dataLayer.push({ ecommerce: null });
        const categoryItems = (categories ?? []).map((c, i) => ({
            item_id: c.id,
            item_name: c.title ?? c.name,
            index: i + 1,
            type: 'category'
        }));
        const productItems = (products ?? []).map((p, i) => ({
            ...LuigisBoxProvider._getLbItem(p),
            index: categoryItems.length + i + 1
        }));
        dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_name: 'Autocomplete',
                search_term: term,
                items: [...categoryItems, ...productItems]
            }
        });
    }

    static _mapListName(plistKey) {
        const map = {
            'relatedProducts': 'Recommendation',
            'titlepage':       'Recommendation',
            'search':          'Search Results',
            'luigisearch':     'Search Results',
        };
        return map[plistKey] ?? 'Product Listing';
    }

    // view_item_list — category / product listing
    static sendProductList(products, plistKey, listContext) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                item_list_name: LuigisBoxProvider._mapListName(plistKey),
                ...(listContext?.scopes ? { scopes: listContext.scopes } : {}),
                ...(listContext?.filters && Object.keys(listContext.filters).length ? { filters: listContext.filters } : {}),
                items: (products ?? []).map((p, i) => ({
                    ...LuigisBoxProvider._getLbItem(p),
                    index: i + 1,
                    type: 'item'
                }))
            }
        });
    }

    // select_item — product click from list
    static onSelectItem(product, listName) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'select_item',
            ecommerce: {
                item_list_name: LuigisBoxProvider._mapListName(listName),
                items: [LuigisBoxProvider._getLbItem(product)]
            }
        });
    }

    // add_to_cart
    static onAddToCart(product, quantity, currency) {
        const item = LuigisBoxProvider._getLbItem(product);
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: currency,
                value: (item.price ?? 0) * (quantity ?? 1),
                items: [{ ...item, quantity: quantity ?? 1 }]
            }
        });
    }

    // purchase — order completion
    static sendorder(order) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'purchase',
            ecommerce: {
                transaction_id: order.invoiceCode,
                value: order.partialPriceTable.cart.totalPriceExclVat, // jen zboží, bez dopravy/platby
                currency: order.currency?.code,
                items: order.orderedProducts.map((cp, i) => ({
                    item_id: cp.product.code,
                    item_name: cp.product.name,
                    index: i,
                    price: cp.priceTable?.totalPriceExclVat,
                    quantity: cp.count
                }))
            }
        });
    }

    // customer identification
    static sendCustomerId(userId) {
        if (!userId) return;
        dataLayer.push({
            event: 'luigisbox.collector.customer_id',
            customer_id: String(userId)
        });
    }
}
